import { render } from "./Reload.vue?vue&type=template&id=5159528e"
import script from "./Reload.vue?vue&type=script&lang=js"
export * from "./Reload.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__